// src/pages/permissions/PermissionForm.js

import React, { useState, useEffect } from 'react';
import useApi from '../../hooks/useApi';
import LoadingSpinner from '../../components/common/LoadingSpinner';
import ErrorMessage from '../../components/common/ErrorMessage';

const PermissionForm = ({ permission, onClose, onSaveSuccess }) => {
  const api = useApi();
  const [formData, setFormData] = useState({
    permissionName: '',
    description: '',
  });
  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (permission) {
      setIsEditing(true);
      setFormData({
        permissionName: permission.name || '',
        description: permission.description || '',
      });
    }
  }, [permission]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      if (isEditing) {
        await api.put(`permissions/${permission._id}`, formData);
        alert("Permission updated successfully!");
      } else {
        await api.post('permissions', formData);
        alert("Permission created successfully!");
      }
      onSaveSuccess();
      onClose();
    } catch (err) {
      setError(err.message || "Operation failed.");
      console.error("Permission form submission error:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      {loading && <LoadingSpinner />}
      {error && <ErrorMessage message={error} />}

      <div>
        <label htmlFor="permissionName" className="block text-sm font-medium text-gray-700">Permission Name</label>
        <input
          type="text"
          name="permissionName"
          id="permissionName"
          value={formData.permissionName}
          onChange={handleChange}
          required
          className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
        />
      </div>

      <div>
        <label htmlFor="description" className="block text-sm font-medium text-gray-700">Description (Optional)</label>
        <textarea
          name="description"
          id="description"
          value={formData.description}
          onChange={handleChange}
          rows="3"
          className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
        ></textarea>
      </div>

      <div className="flex justify-end space-x-3 mt-6">
        <button
          type="button"
          onClick={onClose}
          className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        >
          Cancel
        </button>
        <button
          type="submit"
          disabled={loading}
          className="px-4 py-2 border border-transparent rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        >
          {loading ? 'Saving...' : (isEditing ? 'Save Changes' : 'Add Permission')}
        </button>
      </div>
    </form>
  );
};

export default PermissionForm;
